import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, getDictionaryItem } from '../../utils';
import { commonStyles, ltrStyles, rtlStyles, parsedHtml, scrollLazyLoad, checkIE } from '../09_RichText/RichText';
import { tealiumCheckRightTextClick, tealiumMergeClickData } from '../../utils/tealium';
var MainText = function MainText(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var richTextBody = get(fields, 'data.item.body.jss');
  var dictionary = get(fields, 'data.dictionary');
  var readMoreLabel = getDictionaryItem(dictionary, 'read more');
  var enableShowMoreButton = get(fields, 'data.item.enableShowMoreButton.jss.value');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    output = _React$useState2[0],
    setOutput = _React$useState2[1];
  var richtextRef = React.useRef();
  var _React$useState3 = React.useState(enableShowMoreButton),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    textHidden = _React$useState4[0],
    setTextHidden = _React$useState4[1];
  var richTextAnalytics = get(fields, 'data.richTextAnalytics');
  React.useEffect(function () {
    if (richTextBody) {
      //setOutput(parsedHtml(richTextBody.value as any));
      var isIE = checkIE();
      if (canUseDOM) {
        var obj = parsedHtml(richTextBody.value, isIE);
        setOutput(obj.output);
        if (obj.images && !isIE) {
          setTimeout(function () {
            scrollLazyLoad();
            window.addEventListener('scroll', scrollLazyLoad);
          }, 1);
        }
      }
    }
    if (richtextRef.current) {
      richtextRef.current.classList.remove('height-fix');
    }
  }, [richTextBody, output]);
  if (!fields) {
    console.warn('MainText component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[MainText component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, pageEditing && /*#__PURE__*/React.createElement("h2", null, "Edit Main Text:"), /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: textHidden ? 'rich-text--hidden' : ''
  }, pageEditing ? /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "rich-text__inner",
    field: richTextBody
  }) : /*#__PURE__*/React.createElement("div", {
    ref: richtextRef,
    className: "rich-text__inner height-fix",
    dangerouslySetInnerHTML: {
      __html: output
    },
    onClick: function onClick(e) {
      return tealiumCheckRightTextClick(e, tealiumMergeClickData(richTextAnalytics, params));
    }
  })), textHidden && /*#__PURE__*/React.createElement("div", {
    className: "rich-text__show-bar"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setTextHidden(false);
    }
  }, readMoreLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className),
    "data-cy": "rich-text"
  }, children);
};
export default MainText;